import { Component, Input } from '@angular/core';
import { ButtonThemeLegacy, Theme } from 'studio-components';
import { ButtonPrecedence } from 'studio-components/dialog/types/button-precedence.type';

@Component({
  selector: 'studio-dialog-button',
  templateUrl: './dialog-button.component.html',
  styleUrls: ['./dialog-button.component.scss'],
})
export class DialogButtonComponent {
  @Input() theme: Theme;
  @Input() text: string;
  @Input() precedence: ButtonPrecedence;
  @Input() disabled = false;
  @Input() buttonTheme: ButtonThemeLegacy;

  // determine correct button theme based on precedence
  precedenceToButtonDarkTheme: { [T in ButtonPrecedence]: ButtonThemeLegacy } = {
    primary: 'secondary',
    secondary: 'tertiary',
    tertiary: 'tertiary',
  };

  get fallbackButtonTheme(): ButtonThemeLegacy {
    const darkButtonTheme = this.precedenceToButtonDarkTheme[this.precedence];
    return (
      this.theme === 'dark' ? `dark-${darkButtonTheme}` : this.precedence
    ) as ButtonThemeLegacy;
  }
}
